import { render, staticRenderFns } from "./rewardCollectEdit.vue?vue&type=template&id=00610c52&scoped=true&"
import script from "./rewardCollectEdit.vue?vue&type=script&lang=js&"
export * from "./rewardCollectEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00610c52",
  null
  
)

export default component.exports